/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SplitDowntimeEntry } from '../../models/split-downtime-entry';

export interface SplitDowntime$Params {
  downtimeId: number;
      body: SplitDowntimeEntry
}

export function splitDowntime(http: HttpClient, rootUrl: string, params: SplitDowntime$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, splitDowntime.PATH, 'post');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

splitDowntime.PATH = '/api/v1/Downtimes/{downtimeId}/SplitDowntime';
